export const path = {
  home: '/home',
  birth: {
    home: '/birth',
    detail: '/birth/detail',
    simple: '/birth/simple'
  },
  personality: {
    home: '/person',
    payment: '/person/payment',
    detail: '/person/detail'
  },
  destiny: {
    home: '/destiny',
    payment: '/destiny/payment',
    detail: '/destiny/detail'
  },
  love: {
    home: '/love',
    payment: '/love/payment',
    detail: '/love/detail'
  },
  relation: {
    home: '/relation',
    payment: '/relation/payment',
    detail: '/relation/detail'
  },
  profession: {
    home: '/profession',
    payment: '/profession/payment',
    detail: '/profession/detail'
  },
  plate: {
    home: '/plate',
    detail: '/plate/detail'
  },
  answer: {
    home: '/answer-book',
    share: '/answer-book/share',
    detail: '/answer-book/detail',
    payment: '/answer-book/payment'
  },
  // 定制择吉
  luck: {
    home: '/luck',
    payment: '/luck/payment',
    detail: '/luck/detail'
  },
  // 宫合报告
  match: {
    home: '/match',
    payment: '/match/payment',
    detail: '/match/detail'
  },
  // 兄弟姐妹合盘
  siblings: {
    home: '/friend',
    payment: '/friend/payment',
    detail: '/friend/detail'
  },
  // 职场合盘
  workplace: {
    home: '/workplace',
    payment: '/workplace/payment',
    detail: '/workplace/detail'
  },
  // 邀请合盘
  inviteMatch: '/invite-match',
  annual: {
    home: '/annual',
    payment: '/annual/payment',
    detail: '/annual/detail',
    schedule: '/annual/schedule',
    info: '/annual/info',
    express: '/annual/express'
  },
  hexagram: {
    home: '/hexagram',
    mHexagram: '/manual-hexagram',
    consult: '/hexagram/consult',
    info: '/hexagram/info',
    detail: '/hexagram/detail'
  },
  // 职能报告
  enterprise: {
    home: '/enterprise',
    detail: '/enterprise/detail'
  },
  career: {
    home: '/career',
    detail: '/career/detail'
  },
  // 学业报告
  academic: {
    home: '/academic',
    detail: '/academic/detail'
  },
  naming: {
    home: '/naming',
    detail: '/naming/detail'
  },
  // 资讯
  information: {
    home: '/information',
    long: '/information/lvideo',
    short: '/information/svideo',
    book: '/information/book',
    article: '/information/article',
    iVideo: '/information/ivideo'
  },
  swiper: '/consult',
  video: '/video',
  share: '/hiseer-card',
  shareApp: '/seerlegend',
  linkApp: '/link-seerlegend',
  mainland: '/mainland',
  android: '/android',
  caution: '/caution',
  fresh: '/fresh',
  freshReport: '/fresh-report',
  freshReportDetail: '/fresh-report-detail'
}
